// extracted by mini-css-extract-plugin
module.exports = {"root":"CompanyLARs_root__31bPI","columnSorter":"CompanyLARs_columnSorter__1x5PA"};